// extracted by mini-css-extract-plugin
export default {"container":"ServiceActivityHeaderComponent_container__kuWeh"};